// extracted by mini-css-extract-plugin
export default {"colors":"\"../../../../../../styles/variables/colors.module.css\"","color-white":"#ffffff","logo":"Logo_logo__8e-H2"};